import { Injectable } from '@angular/core';
import { Order } from "../models/order"
import { OrderItem } from "../models/order-item"
import { HTTPService } from "./http.service";
import { PaginatedResultResponse } from 'app/shared/models/paginated-results-response';
import { PaginatedResultsLoader } from 'app/shared/models/paginated-results-loader';
import { PaginatedResultsLoaderFactory } from 'app/shared/services/pagination-results-loader-factory.service';

@Injectable()
export class OrderService {
  private _lastOrder:Order;
  private _orders:Order[];
  private _resultsLoader:PaginatedResultsLoader<Order>;

  constructor(
    private http:HTTPService,
    private _paginationFactory:PaginatedResultsLoaderFactory
  ) { 
    // this._lastOrder = new Order();
    // this._lastOrder.status = 'paid';
    // this._lastOrder.id = 1;
    
    // let item = new OrderItem();
    // item.price = 5.00;
    // item.quantity = 5;
    // item.item = {name: "Sexual Addiction"};
    // item.total = 25.00;
    // this._lastOrder.items.push(item);
    // this._lastOrder.total = item.total;
  }

  public getOrder(orderId:number) : Promise<Order> {
    return this.http.get("/orders/" + orderId).then((response) => {
      let orderData = response.json() as any;
      return this.populateOrder(orderData);
    });
  }

  public storeLastOrder(order) {
    this._lastOrder = order;
  }

  public getLastOrder() {
    if (this._lastOrder) {
      return Promise.resolve(this._lastOrder);
    }

    return this.getPaginatedOrderHistory().then((data:PaginatedResultResponse<Order>) => {
      if (data.results.length) {
        // return the first order since they are in reverse order.
        this._lastOrder = data.results[0];
      }
      else {
        this._lastOrder = null;
      }
      return this._lastOrder;
    });
  }

  public getOrderHistory() {
    let queryFunction = this.getPaginatedOrderHistory.bind(this);
    this._resultsLoader = this._paginationFactory.getResultsLoader<Order>(queryFunction);
    return this._resultsLoader.getResults()
        .then((orders:Order[]) => {
            this._orders = orders;
            return orders;
    });
  }

  public hasMoreResults() : boolean {
    return this._resultsLoader.hasMoreResults();
  }

  public loadMore() : Promise<Order[]> {
      // load more results
      return this._resultsLoader.loadMore()
      .then((results:Order[]) => {
          console.log(results);
          this._orders = results;
          return results;
      });
  }

  private getPaginatedOrderHistory(cursor?:string) : Promise<PaginatedResultResponse<Order>> {
    var data: any = {
			cursor: cursor || null
			, limit: 10
		};
	
    return this.http.get("/orders/", data).then((response) => {

      let data = response.json() as PaginatedResultResponse<Order>;
        
      if (data && data.results.length) {
        data.results.map(o => {
          return this.populateOrder(o);
        });

      }
      return data;
    });
  }

  private populateOrder(src:any) {
    let object = Object.assign(new Order(), src);
    object.creation_date = new Date(src.creation_date);
    object.last_update_date = new Date(src.last_update_date);
    return object;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/order.service.ts